import APIClient from './client'

const base = (brandId) => `/v1/brands/${brandId}/hs_custom_fields`

// The custom-field map's keys are user data (e.g. `utm_source`) and must round-trip
// verbatim, so this module deliberately does NOT run the payload through humps.
const mapRecord = (data) => ({
  id: data.id,
  name: data.name,
  hsCustomFields: data.hs_custom_fields,
})

const get = (brandId) => {
  return APIClient().get(base(brandId))
    .then(response => mapRecord(response.data))
}

const save = (brandId, hsCustomFields) => {
  return APIClient().post(base(brandId), { hs_custom_fields: hsCustomFields })
    .then(response => mapRecord(response.data))
}

const brandHsCustomFieldsAPIs = {
  get,
  save,
}

export default brandHsCustomFieldsAPIs
